module.exports = __webpack_public_path__ + "static/media/T2.552cf936.jpeg";